import { render, staticRenderFns } from "./b11.vue?vue&type=template&id=066467ba&scoped=true"
import script from "./b11.vue?vue&type=script&lang=js"
export * from "./b11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066467ba",
  null
  
)

export default component.exports